import { HttpRequest, HttpResponse } from '@angular/common/http';
import type {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import type { Observable } from 'rxjs';
import { reviveDatesDeep } from '@ups/xplat/utils';

@Injectable({
  providedIn: 'root',
})
export class HttpReviveDatesInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      map((event) => {
        if (!(event instanceof HttpResponse) || event.body == null) {
          return event;
        }

        // Only revive dates for JSON payloads. Binary responses (blob/arraybuffer)
        // must stay untouched for APIs like print/download endpoints.
        if (req.responseType !== 'json') {
          return event;
        }

        return event.clone({
          body: reviveDatesDeep(event.body),
        });
      })
    );
  }
}
